import React from 'react';
import Row from 'app/shared/core/Row';
import SkeletonLine from 'app/shared/modules/skeleton/SkeletonLine';
import SkeletonTitle from 'app/shared/modules/skeleton/SkeletonTitle';
import {
  skeletonAreaCard,
  skeletonAreaCardContainer,
  skeletonAreaCardContentContainer,
} from './skeletonAreaCard.styles';

const SkeletonAreaCard = () => {
  return (
    <div className={skeletonAreaCard}>
      <div className={skeletonAreaCardContainer}>
        <div className={skeletonAreaCardContentContainer}>
          <Row>
            <SkeletonTitle width="45%" />
          </Row>
          <Row>
            <SkeletonLine width="80%" />
          </Row>
        </div>
      </div>
    </div>
  );
};

export default SkeletonAreaCard;
